<template>
    <div 
        class="t-mobile mobile"
        @click="hideTip"
    >
        <ALoader v-if="mapLoading" />
        <slot name="header"/>
        <div
            :class="['mobile__main-container',{'mobile__main-container--static': mapLoading} ]"
            role="main"
        >
            <MClickTip v-if="showTip && isShowTip"/>
            <slot name="main" />
            <OMMap />
        </div>
        <slot name="footer" />
        <slot name="modal" />
    </div>
</template>

<script>
import { mapState } from 'vuex';
import ALoader from '../../atoms/a-loader/a-loader';
import OMMap from '../../unique-organisms/o-m-map/o-m-map';
import MClickTip from '../../molecules/m-click-tip/m-click-tip';

import { MOBILE_ROOT } from '../../../utils/constants/pages';

export default {
    name: 'TMobile',
    data() {
        return {
            showTip: true
        }
    },
    components: {
        OMMap,
        ALoader,
        MClickTip
    },
    computed: {
        ...mapState({
            mapLoading: state => state.mapLoading
        }),
        isShowTip() {
            return this.$route.name.includes(MOBILE_ROOT);
        }
    },
    methods: {
        hideTip() {
            this.showTip = false;
        }
    }
}
</script>

<style lang="scss">
@import "t-mobile";
</style>
